// extracted by mini-css-extract-plugin
export default {"card":"TemplateListItem_card__lIRUZ","category":"TemplateListItem_category__33DLo","thumbnail":"TemplateListItem_thumbnail__chhtk","title":"TemplateListItem_title__rsLCv"};